import { FormlyFieldConfig } from '@ngx-formly/core';
import { advancedSection, COMMON_FIELD_CONFIGS } from './field-config-shared';

/**
 * photo: type → label → required → allowMultiplePhotos → [Advanced: width, filenamePrefix, prefillLastValue]
 *
 * Preview/upload functionality is part of the view (rendering) component, not the config editor.
 */
export function getPhotoFieldConfigFields(): FormlyFieldConfig[] {
  return [
    COMMON_FIELD_CONFIGS['type'],
    COMMON_FIELD_CONFIGS['label'],
    COMMON_FIELD_CONFIGS['required'],
    {
      key: 'allowMultiplePhotos',
      type: 'checkbox',
      props: {
        label: 'formBuilder.allowMultiplePhotos',
      },
    },
    advancedSection(
      COMMON_FIELD_CONFIGS['width'],
      {
        key: 'filenamePrefix',
        type: 'text',
        props: {
          label: 'formBuilder.filenamePrefix',
          placeholder: 'formBuilder.filenamePrefixPlaceholder',
          description: 'formBuilder.filenamePrefixHelp',
        },
      },
      COMMON_FIELD_CONFIGS['prefillLastValue'],
    ),
  ];
}
